import React, { useState, useCallback } from 'react';
import { useAppSelector } from 'store/hooks';
import { programsPermissionsSelector } from 'store/account/account.selector';

const IFrameView: React.FC<{ account: IUserPortal; programId: string }> = ({
  account,
  programId,
}) => {
  const [isSwiping, setIsSwiping] = useState(false);
  const [startX, setStartX] = useState(0);
  const [startY, setStartY] = useState(0);
  const [isMoving, setIsMoving] = useState(false);

  const token = account.accessToken || '';
  const userId = account.id || 0;
  const programsPermissions = useAppSelector(programsPermissionsSelector);

  let url = 'https://www.palmettoeoc.com/app/';
  const programName = programsPermissions?.find(
    (program) => program.pvServiceID === Number(programId)
  )?.pvServiceName;
  if (programName) {
    url += programName;
  }

  const handleTouchStart = useCallback((event: React.TouchEvent) => {
    setStartX(event.touches[0].clientX);
    setStartY(event.touches[0].clientY);
    setIsMoving(false);
  }, []);

  const handleTouchMove = useCallback(
    (event: React.TouchEvent) => {
      const deltaX = Math.abs(event.touches[0].clientX - startX);
      const deltaY = Math.abs(event.touches[0].clientY - startY);

      // Only detect horizontal swipes (not vertical scrolling)
      if (deltaX > 10 && deltaX > deltaY) {
        setIsSwiping(true);
        setIsMoving(true);
      }
    },
    [startX, startY]
  );

  const handleTouchEnd = useCallback(() => {
    if (isMoving) {
      setTimeout(() => {
        setIsSwiping(false);
        setIsMoving(false);
      }, 300);
    }
  }, [isMoving]);

  return (
    <div
      className={'iframe-wrapper'}
      style={{
        width: '100%',
        height: '100%', // 100VH causes issues on safari
        border: 'none',
        position: 'relative',
        touchAction: 'none',
        background: Number(programId) === 90 ? 'white' : undefined
      }}
      onTouchStart={handleTouchStart}
      onTouchMove={handleTouchMove}
      onTouchEnd={handleTouchEnd}>
      <iframe
        src={`${url}?access_token=${token}&userId=${userId}`}
        style={{
          width: '100%',
          height: '100%',
          border: 'none',
          pointerEvents: isSwiping ? 'none' : 'auto',
        }}
        title='External Project'
        allowFullScreen
      />
    </div>
  );
};

export default IFrameView;
